import {styled} from "@mui/material";
import {Form, Formik} from "formik";
import {TableTabs} from "components/Table/components";
import Limitation from "./addedInfoChildren/Limitation";
import LimitationTime from "./addedInfoChildren/LimitationTime";
import {useState} from "react";
import {useSelector} from "react-redux";

const AddedInfoContainer = styled("div")(({theme}) => ({
    backgroundColor: "white",
    borderRadius: theme.shape.borderRadius,
    marginTop: "32px",
    marginBottom: "50px",
}));
const BoxUpper = styled("div")(({theme}) => ({
    borderBottom: `solid 3px ${theme.palette.disabled.light}`,
}));

const formTabs = [
    // {
    //     title: 'دسترسی ها',
    //     key: "access",
    //     Component: Access
    // },
    {
        title: "محدودیت ها",
        key: "limitations",
        Component: Limitation,
    },
    {
        title: "محدودیت های زمانی",
        key: "limitation-time",
        Component: LimitationTime,
    },
];
const UserAddedInfo = () => {
    //@ts-ignore
    const editItem = useSelector((state) => state).formReducer.editItem;

    const initialValues = {
        timeLimitation: editItem?.accessTimeLimit?.enableHour,
        dayLimitation: editItem?.accessTimeLimit?.enableWeekday,
        dateLimitation: editItem?.accessTimeLimit?.enableDateRange,
    };

    const onSubmit = () => {};

    const [activeTab, setActiveTab] = useState(formTabs[0]);

    const {Component} = activeTab;
    const handleChange = (tab: (typeof formTabs)[0]) => {
        setActiveTab(tab);
    };

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {(formik) => (
                <Form>
                    <AddedInfoContainer>
                        <BoxUpper>
                            <TableTabs
                                tabs={formTabs}
                                activeTabKey={formTabs.findIndex((item) => item.key === activeTab.key)}
                                activeTab={activeTab}
                                setActiveTab={handleChange}
                            />
                        </BoxUpper>
                        <Component/>
                    </AddedInfoContainer>
                </Form>
            )}
        </Formik>
    );
};

export default UserAddedInfo;
